import { z } from 'zod';
import { responsiveCornersSchema } from '../../mixins';

export const borderRadiusV0Schema = z.object({
    version: z.literal(0),
    /**
     * Legacy's `isIndependentCorners` is **not** here, for the same reason
     * `border` drops its own: the four corners already say whether they are
     * edited separately. The rounding control writes all four on every edit and
     * flattens them onto the top-left when the switch goes off, so four equal
     * corners *is* the shared radius — see {@link isBorderRadiusIndependent},
     * which derives it at read time.
     */
    corners: responsiveCornersSchema,
});
